import { render, staticRenderFns } from "./Universal.vue?vue&type=template&id=2a9e35e4&"
import script from "./Universal.vue?vue&type=script&lang=js&"
export * from "./Universal.vue?vue&type=script&lang=js&"
import style0 from "./Universal.vue?vue&type=style&index=0&id=2a9e35e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports